import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UrlSignature } from '../common/apiEndpoint';
import { EducationalBackground } from './EducationalBackground';

@Injectable()
export class EducationalBackgroundService {
  constructor(
    private httpClient: HttpClient,
    private urlSignature: UrlSignature,
  ) {}

  getEducationalBackgroundDetails(
    personId: String,
  ): Observable<EducationalBackground[]> {
    const url = this.urlSignature.institutionUrl + personId;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as EducationalBackground[]));
  }
}
